import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, mergeProps as _mergeProps, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "position-relative elevation-4" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_station_marker_cluster = _resolveComponent("station-marker-cluster")!
  const _component_station_circle_selector = _resolveComponent("station-circle-selector")!
  const _component_station_rectangle_selector = _resolveComponent("station-rectangle-selector")!
  const _component_tool_button_with_menu = _resolveComponent("tool-button-with-menu")!
  const _component_v_tooltip = _resolveComponent("v-tooltip")!
  const _component_text_field_with_date_picker = _resolveComponent("text-field-with-date-picker")!
  const _component_shared_map = _resolveComponent("shared-map")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_v_btn, {
      "data-testid": "retract-button",
      class: "retract-button",
      onClick: _ctx.emitHide
    }, {
      default: _withCtx(() => [
        _createVNode(_component_v_icon, { color: "primary" }, {
          default: _withCtx(() => [...(_cache[0] || (_cache[0] = [
            _createTextVNode(" mdi-chevron-right ", -1)
          ]))]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["onClick"]),
    _createVNode(_component_shared_map, {
      "drawing-tool-cursor": _ctx.drawingToolCursor,
      onMousedown: _ctx.handleMouseDown,
      onMouseup: _ctx.handleMouseUp,
      onMousemove: _ctx.handleMapMouseMove,
      onLMapReady: _ctx.setLMap
    }, {
      map: _withCtx(() => [
        (_ctx.clusterReady)
          ? (_openBlock(), _createBlock(_component_station_marker_cluster, {
              key: 0,
              map: _ctx.lMap,
              "stations-with-status": _ctx.allStationsWithStatus
            }, null, 8, ["map", "stations-with-status"]))
          : _createCommentVNode("", true),
        (_ctx.currentTool === _ctx.Tool.circle && _ctx.toolAnchorStart && _ctx.toolAnchorEnd)
          ? (_openBlock(), _createBlock(_component_station_circle_selector, {
              key: 1,
              map: _ctx.lMap,
              "start-anchor": _ctx.toolAnchorStart,
              "end-anchor": _ctx.toolAnchorEnd,
              finished: _ctx.toolState === _ctx.ToolState.finished,
              purpose: _ctx.toolPurpose,
              "data-testid": "station-map-circle-selector",
              onRemove: _ctx.resetTools
            }, null, 8, ["map", "start-anchor", "end-anchor", "finished", "purpose", "onRemove"]))
          : _createCommentVNode("", true),
        (
            _ctx.currentTool === _ctx.Tool.rectangle && _ctx.toolAnchorStart && _ctx.toolAnchorEnd
          )
          ? (_openBlock(), _createBlock(_component_station_rectangle_selector, {
              key: 2,
              map: _ctx.lMap,
              "start-anchor": _ctx.toolAnchorStart,
              "end-anchor": _ctx.toolAnchorEnd,
              finished: _ctx.toolState === _ctx.ToolState.finished,
              purpose: _ctx.toolPurpose,
              "data-testid": "station-map-rectangle-selector",
              onRemove: _ctx.resetTools
            }, null, 8, ["map", "start-anchor", "end-anchor", "finished", "purpose", "onRemove"]))
          : _createCommentVNode("", true)
      ]),
      tools: _withCtx(() => [
        _createVNode(_component_tool_button_with_menu, {
          class: "ml-4",
          "test-id": "rectangle",
          items: _ctx.rectangleToolItems
        }, null, 8, ["items"]),
        _createVNode(_component_tool_button_with_menu, {
          class: "ml-4",
          "test-id": "pin",
          items: _ctx.circleToolItems
        }, null, 8, ["items"]),
        _createVNode(_component_v_tooltip, {
          text: _ctx.t('station_map.deselect-all-stations'),
          bottom: "",
          "open-delay": 200
        }, {
          activator: _withCtx(({ props }) => [
            _createVNode(_component_v_btn, _mergeProps(props, {
              class: 'ml-4 map-button zamg-button-outline-primary',
              variant: "outlined",
              elevation: "2",
              "data-testid": "station-map-delete",
              onClick: _ctx.handleUnselectStations
            }), {
              default: _withCtx(() => [
                _createVNode(_component_v_icon, { color: "primary" }, {
                  default: _withCtx(() => [...(_cache[1] || (_cache[1] = [
                    _createTextVNode(" mdi-delete-outline ", -1)
                  ]))]),
                  _: 1
                })
              ]),
              _: 1
            }, 16, ["onClick"])
          ]),
          _: 1
        }, 8, ["text"]),
        _createVNode(_component_text_field_with_date_picker, {
          value: _ctx.stationStore.filters.startDate || null,
          testid: 'map-start-date',
          "allowed-date-range": [
            _ctx.datasetStore.metadata?.startDate,
            _ctx.datasetStore.metadata?.endDate,
          ],
          "text-field-props": {
            style: 'margin-left: 16px; width: 190px; max-width: 190px;',
            variant: 'solo',
            density: 'compact',
            placeholder: _ctx.t('start_date'),
          },
          "extra-small-height": "",
          "selected-date-is-start-date": true,
          "reference-date": _ctx.stationStore.filters.endDate,
          onDateSelected: _ctx.handleStartDateSelected
        }, null, 8, ["value", "allowed-date-range", "text-field-props", "reference-date", "onDateSelected"]),
        _createVNode(_component_text_field_with_date_picker, {
          value: _ctx.stationStore.filters.endDate || null,
          testid: 'map-end-date',
          "allowed-date-range": [
            _ctx.datasetStore.metadata?.startDate,
            _ctx.datasetStore.metadata?.endDate,
          ],
          "text-field-props": {
            style: 'margin-left: 16px; width: 190px; max-width: 190px;',
            variant: 'solo',
            density: 'compact',
            placeholder: _ctx.t('end_date'),
          },
          "extra-small-height": "",
          "selected-date-is-start-date": false,
          "reference-date": _ctx.stationStore.filters.startDate,
          onDateSelected: _ctx.handleEndDateSelected
        }, null, 8, ["value", "allowed-date-range", "text-field-props", "reference-date", "onDateSelected"])
      ]),
      _: 1
    }, 8, ["drawing-tool-cursor", "onMousedown", "onMouseup", "onMousemove", "onLMapReady"])
  ]))
}